__turbopack_context__.v({
  "leads": "dealLeads-module-scss-module__oRfVfa__leads",
});
